import { atom, selector } from 'recoil'
import { SEARCH_ATOM_KEYS } from './keys'

const STORE_KEYWORD = atom<string[]>({
  key: SEARCH_ATOM_KEYS.STORE_KEYWORD,
  default: JSON.parse(localStorage.getItem('sauceFlexCollect') || '[]') as string[],
})

export const KEYWORD_UPDATE = selector<string[]>({
  key: SEARCH_ATOM_KEYS.KEYWORD_UPDATE,
  get: ({ get }) => {
    const keyword = get(STORE_KEYWORD)
    return keyword
  },
  set: ({ set }, newValue) => {
    localStorage.setItem('sauceFlexCollect', JSON.stringify(newValue))
    set(STORE_KEYWORD, newValue)
  },
})
